/* Lady L. Fashion — scripts du thème : apparitions au défilement, menu mobile, panier, formulaire VIP. */
(function () {
  'use strict';

  var strings = window.llStrings || {};
  var moneyFormat = window.llMoneyFormat || '{{amount_with_comma_separator}} €';

  /* ---------- Apparition des blocs au défilement ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.ll-reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -80px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Léger décalage de l'image d'en-tête au défilement ---------- */
  function initParallax() {
    var nodes = document.querySelectorAll('[data-ll-parallax]');
    if (!nodes.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function update() {
      ticking = false;
      nodes.forEach(function (node) {
        var section = node.closest('section');
        if (!section) return;
        var rect = section.getBoundingClientRect();
        var progress = Math.min(Math.max(-rect.top / rect.height, 0), 1);
        node.style.transform = 'translateY(' + (progress * parseFloat(node.dataset.llParallax)) + 'px)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* ---------- Menu mobile ---------- */
  function initHeader() {
    var header = document.querySelector('.ll-header');
    if (!header) return;
    var burger = header.querySelector('.ll-burger');
    if (!burger) return;
    burger.addEventListener('click', function () {
      var open = header.hasAttribute('data-open');
      if (open) header.removeAttribute('data-open'); else header.setAttribute('data-open', '');
      burger.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* ---------- Panier ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    var noDecimals = String(Math.round(cents / 100));
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/<[^>]*>/g, '');
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  var toastTimer;
  function toast(message) {
    var el = document.querySelector('.ll-toast');
    if (!el || !message) return;
    el.textContent = message;
    el.setAttribute('data-show', '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.removeAttribute('data-show'); }, 3200);
  }

  function initCart() {
    var drawer = document.querySelector('.ll-drawer');
    if (!drawer) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var linesEl = drawer.querySelector('[data-ll-cart-lines]');
    var emptyEl = drawer.querySelector('[data-ll-cart-empty]');
    var footEl = drawer.querySelector('[data-ll-cart-foot]');
    var totalEl = drawer.querySelector('[data-ll-cart-total]');
    var countEl = document.querySelector('.ll-cartbtn__count');
    var icons = {
      minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
      plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg>',
      trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6"/></svg>'
    };

    function open() { document.body.setAttribute('data-cart-open', ''); }
    function close() { document.body.removeAttribute('data-cart-open'); }

    function render(cart) {
      var count = cart.item_count || 0;
      if (countEl) {
        countEl.textContent = count;
        countEl.hidden = count === 0;
      }
      emptyEl.hidden = count !== 0;
      footEl.hidden = count === 0;
      totalEl.textContent = formatMoney(cart.total_price);
      linesEl.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy">' : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + escapeHtml(item.variant_title) : '';
        return '<div class="ll-card ll-cartline" data-key="' + escapeHtml(item.key) + '">' + img +
          '<div class="ll-cartline__main">' +
          '<p class="ll-cartline__title">' + escapeHtml(item.product_title) + variant + '</p>' +
          '<p class="ll-cartline__meta">' + formatMoney(item.final_price) + '</p>' +
          '<div class="ll-qty">' +
          '<button type="button" data-ll-qty="' + (item.quantity - 1) + '" aria-label="' + escapeHtml(strings.decrease) + '">' + icons.minus + '</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-ll-qty="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(strings.increase) + '">' + icons.plus + '</button>' +
          '</div></div>' +
          '<button type="button" class="ll-cartline__remove" data-ll-qty="0" aria-label="' + escapeHtml(strings.remove) + '">' + icons.trash + '</button>' +
          '</div>';
      }).join('');
    }

    function request(path, body) {
      return fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || strings.error);
          return data;
        });
      });
    }

    function refresh() {
      return request('cart.js').then(render);
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-ll-cart-open]')) { event.preventDefault(); open(); return; }
      if (event.target.closest('[data-ll-cart-close]')) { close(); return; }
      var qtyBtn = event.target.closest('[data-ll-qty]');
      if (qtyBtn && drawer.contains(qtyBtn)) {
        var line = qtyBtn.closest('[data-key]');
        request('cart/change.js', { id: line.dataset.key, quantity: parseInt(qtyBtn.dataset.llQty, 10) })
          .then(render)
          .catch(function (error) { toast(error.message); });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[data-ll-add]');
      if (!form) return;
      event.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var id = form.querySelector('[name="id"]').value;
      var qtyInput = form.querySelector('[name="quantity"]');
      if (button) button.disabled = true;
      request('cart/add.js', { items: [{ id: Number(id), quantity: qtyInput ? Number(qtyInput.value) || 1 : 1 }] })
        .then(refresh)
        .then(function () { open(); toast(strings.added); })
        .catch(function (error) { toast(error.message); })
        .then(function () { if (button) button.disabled = false; });
    });

    refresh().catch(function () {});
  }

  /* ---------- Formulaire VIP : le niveau choisi devient une étiquette cliente ---------- */
  function initVipForm() {
    document.querySelectorAll('[data-ll-vip-form]').forEach(function (form) {
      var select = form.querySelector('[data-ll-level]');
      var tags = form.querySelector('[name="contact[tags]"]');
      if (!select || !tags) return;
      var base = tags.dataset.base || tags.value;
      function sync() {
        tags.value = select.value ? base + ', ' + select.value : base;
      }
      select.addEventListener('change', sync);
      sync();
    });
  }

  function init() {
    initReveal();
    initParallax();
    initHeader();
    initCart();
    initVipForm();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.ll-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
